import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthenticatorsComponent} from './core/authenticators/authenticators.component';
import {EnrollmentComponent} from './core/enrollment/enrollment.component';
import {HomeComponent} from './core/home/home.component';
import {IdentityComponent} from './core/identity/identity.component';
import {SessionsComponent} from './core/sessions/sessions.component';
import {ErrorComponent} from './core/error/error.component';
import {ApplicationsComponent} from "./core/applications/applications.component";
import {customGuard} from "./custom-guard.service";

const routes: Routes = [
  { path: '', redirectTo: 'applications', pathMatch:'full'},
  { path: 'authenticators', component: AuthenticatorsComponent, canActivate: [customGuard] },
  { path: 'sessions', component: SessionsComponent, canActivate: [customGuard] },
  { path: 'identity', component: IdentityComponent, canActivate: [customGuard] },
  { path: 'enrollment', component: EnrollmentComponent, canActivate: [customGuard] },
  { path: 'applications', component: ApplicationsComponent, canActivate: [customGuard] },
  { path: 'home', component: HomeComponent, canActivate: [customGuard] },
  { path: 'enrollment/:username', component: EnrollmentComponent, canActivate: [customGuard] },
  { path: 'error', component: ErrorComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
